import { hasUsableImageUrl } from "./placeholderImages";

/**
 * URL hiển thị ảnh từ S3/CDN (settings, hero, …).
 * - Ưu tiên ghép REACT_APP_CDN_URL + key khi có (tránh URL cũ/sai trong DB, đồng bộ với backend AWS_S3_PUBLIC_BASE_URL).
 * - Fallback: url tuyệt đối từ API.
 */
export function resolveAssetDisplayUrl(url, key) {
  const baseRaw = (process.env.REACT_APP_CDN_URL || "").trim().replace(/\/$/, "");
  const k = typeof key === "string" ? key.trim() : "";

  if (baseRaw && k) {
    const base = /^https?:\/\//i.test(baseRaw) ? baseRaw : `https://${baseRaw}`;
    return `${base}/${k.split("/").map(encodeURIComponent).join("/")}`;
  }

  const u = typeof url === "string" ? url.trim() : "";
  if (u && /^https?:\/\//i.test(u)) return u;
  if (u && u.startsWith("//")) return `https:${u}`;
  return u;
}

/** Chuỗi URL hoặc asset `{ url, key }` từ API → một URL hiển thị (hoặc rỗng). */
export function assetToDisplayUrl(asset) {
  if (asset == null || asset === "") return "";
  if (typeof asset === "string") {
    const t = asset.trim();
    return hasUsableImageUrl(t) ? t : "";
  }
  if (typeof asset === "object") {
    const u = resolveAssetDisplayUrl(asset.url, asset.key);
    return hasUsableImageUrl(u) ? String(u).trim() : "";
  }
  return "";
}

/**
 * Gộp ảnh bìa + gallery + heroGallery + ảnh trong mediaBlocks → dùng cho bản đồ / list.
 * Trả về `image` (URL đầu) và `gallery` (các URL còn lại, không trùng).
 */
export function normalizeLocationMapMedia(item) {
  const urls = [];
  const seen = new Set();
  const add = (asset) => {
    const u = assetToDisplayUrl(asset);
    if (!u || seen.has(u)) return;
    seen.add(u);
    urls.push(u);
  };

  add(item?.image);
  if (Array.isArray(item?.gallery)) item.gallery.forEach(add);
  if (Array.isArray(item?.heroGallery)) item.heroGallery.forEach(add);
  if (Array.isArray(item?.media?.images)) item.media.images.forEach(add);
  const blocks = item?.mediaBlocks;
  if (Array.isArray(blocks)) {
    for (const b of blocks) {
      if (String(b?.type || "").toLowerCase() !== "image") continue;
      add(b?.image);
    }
  }

  return {
    image: urls[0] || "",
    gallery: urls.slice(1),
  };
}
